import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import { Course } from '@/models/Course';
import { uniqueId } from 'lodash';
import { Model } from './Model';
import { Temp } from './Temp';

export default class CoursePath extends Model {
  id!: number;
  status!: VersioningStatusEnum;
  version: number = 1;
  lastUpdate!: string | null;
  lessonsQuantity!: number | null;
  isbnCode!: string | null;
  slug!: string;
  course!: Course;
  objectives: Objective[] = [];
  rating!: number | null;
  hasLessonBlocks!: boolean;

  constructor(coursePath?: Partial<CoursePath>) {
    super(coursePath);
    Object.assign(this, coursePath);
  }
}

export class Objective {
  id!: number;
  name: string = '';
  description: string | null = null;

  constructor(objective?: Partial<Objective>) {
    if (objective) {
      Object.assign(this, objective);
    }
  }
}

export class TempObjective extends Objective implements Temp {
  tempId?: string = uniqueId();

  constructor(tempObjective?: Partial<TempObjective>) {
    super();
    Object.assign(this, tempObjective);
  }
}
